<template>
  <div class="invoice-records-container">
    <div class="card-title" style="margin-top: 20px;">
      <el-link @click="getList">合同归档信息<i class="el-icon-refresh"></i></el-link>
    </div>
    <div class="formCard default-table">
      <el-table :data="tableData" show-summary :summary-method='getSummaries'>
        <el-table-column label="序号" align="center" type="index" width="80"/>
        <el-table-column label="合同编号" prop="contract_no" align="center" width="160" sortable></el-table-column>
        <el-table-column label="合同金额" prop="contract_amount" align="center" sortable></el-table-column>
        <el-table-column label="收款形式" prop="payment_method_alias" align="center" sortable></el-table-column>
        <el-table-column label="是否保量" prop="is_quantity" header-align="center"
                         align="center"
                         :min-width="100">
          <template slot-scope="{row}">{{ quantityMap[row.is_quantity] || '-' }}</template>
        </el-table-column>
        <el-table-column label="佣金比例" prop="commission_rate" header-align="center"
                         align="center"
                         :min-width="100">
          <template slot-scope="{row}"><span class="rate">{{row.commission_rate||'-'}}</span></template>
        </el-table-column>
        <!--        <el-table-column label="合同归档" prop="contract_filed" align="center" sortable></el-table-column>-->
        <el-table-column label="财务备注" prop="f_remark" align="center" sortable></el-table-column>
        <el-table-column label="创建时间" prop="created_at" align="center" sortable></el-table-column>
        <el-table-column label="修改时间" prop="updated_at" align="center" sortable></el-table-column>
        <!--        <el-table-column label="备注" prop="remark" align="center" sortable></el-table-column>-->
        <el-table-column v-if="canRevoke" label="操作" prop="remark" align="center">
          <template slot-scope="{row}">
            <el-link type="primary" icon="el-icon-refresh-left" title="撤销合同归档记录"
                     @click="revokeContract(row.id)">撤销
            </el-link>
          </template>
        </el-table-column>
      </el-table>
    </div>
  </div>
</template>
<!--            <el-form :model="order" :inline="true" size="mini">-->
<!--              <el-form-item label="合同编号">-->
<!--                <div class="input-val">-->
<!--                  <span>{{ contract.contract_no || '&#45;&#45;' }}</span>-->
<!--                </div>-->
<!--              </el-form-item>-->
<!--              <el-form-item label="合同金额">-->
<!--                <div class="input-val">-->
<!--                  <span>{{ contract.contract_amount || '&#45;&#45;' }}</span>-->
<!--                </div>-->
<!--              </el-form-item>-->
<!--              <el-form-item label="收款形式">-->
<!--                <el-select v-model="contract.payment_method" clearable disabled>-->
<!--                  <el-option :value="1" label="先票后款"></el-option>-->
<!--                  <el-option :value="2" label="先款后票"></el-option>-->
<!--                  <el-option :value="3" label="预付款后开票"></el-option>-->
<!--                  <el-option :value="0" label="未定义"></el-option>-->
<!--                </el-select>-->
<!--              </el-form-item>-->
<!--              <el-form-item label="合同归档">-->
<!--                <el-select v-model="contract.contract_filed" clearable disabled>-->
<!--                  <el-option :value="1" label="已归档"></el-option>-->
<!--                  <el-option :value="0" label="未归档"></el-option>-->
<!--                </el-select>-->
<!--              </el-form-item>-->
<!--              <el-form-item label="财务备注">-->
<!--                <el-input class="el-input-c" v-model="contract.f_remark" style="width: 300px"-->
<!--                          placeholder="请输入财务备注" show-word-limit readonly></el-input>-->
<!--              </el-form-item>-->
<!--              <el-form-item v-if="contract.contract_filed===1">-->
<!--                <el-button type="text" icon="el-icon-refresh-left" title="撤销合同归档记录"-->
<!--                           @click="revokeContract(contract,order)">撤销-->
<!--                </el-button>-->
<!--              </el-form-item>-->
<!--            </el-form>-->

<script>
import {revokeOrderContract} from "@/api/order";
import {getOrderContractByOrderId} from "@/api/adOrder";

/**
 * 开票记录
 */
export default {
  name: "InvoiceRecords",
  props: {
    orderId: {
      type: [Number, String],
      required: true
    },
    canRevoke: Boolean
  },
  data() {
    return {
      tableData: [],
      quantityMap: {'Y': '是', 'N': '否'}
    }
  },
  computed: {
    userAuth() {
      return this.$store.getters.getUserAuth;
    },
  },
  watch: {
    orderId() {
      this.getList()
    }
  },
  created() {
    this.getList()
  },
  methods: {
    getSummaries(param) {
      const { columns, data } = param
      const sums = []
      columns.forEach((column, index) => {
        if (index === 0) {
          sums[index] = '合计'
          return
        }
        if (['contract_amount'].indexOf(column.property) > -1) {
          const values = data.map(item => Number(item[column.property]))
          if (!values.every(value => isNaN(value))) {
            sums[index] = values.reduce((prev, curr) => {
              const value = Number(curr)
              if (!isNaN(value)) {
                return prev + curr
              } else {
                return prev
              }
            }, 0)
            sums[index] += ' '
          } else {
            sums[index] = 'N/A'
          }

          switch (column.property) {
            case 'ratio':
              sums[index] = this.$utils.numberFormat(sums[index], 0) + ' %'
              break
              // case 'month_amount':
              //   sums[index] = '¥' + this.moneyFormat(sums[index])
              //   break
            default:
              sums[index] = '¥ ' + this.$utils.numberFormat(sums[index], 2)
              break
          }
        }

      })

      return sums
    },

    async getList() {
      const {list} = await getOrderContractByOrderId(this.orderId).then((res) => {
        return res.data || {}
      });
      this.tableData = list || []
      // this.tableData.map(_ => {
      //   _.popDel = false
      // })
    },
    /**
     * 删除开票记录
     * @param id
     * @param isSure
     */
    //撤销合同归档记录
    revokeContract(id) {
      //撤销合同归档
      // this.$notify.info(`撤销当前订单（ID:${order.id}）的合同【${contract.contract_no}】`)
      this.$confirm('此操作将【撤销】该订单的合同归档记录, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        let postData = {order_id: this.orderId, id: id}
        let respData = await revokeOrderContract(postData)
        if (respData.success) {
          this.msgSuccess('【已撤销】订单的合同归档记录!')
          await this.getList()
        } else {
          this.msgWarn(respData.message || '操作失败')
        }
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消'
        });
      });

    }
  },
}
</script>
<style lang="scss">
.invoice-records-container {
  .del-btn {
    padding: 0;
  }
}
</style>
